import React, { useEffect, useState } from "react";
import AddAnotherServiceUser from "../../components/AddAnotherServiceUser/AddAnotherServiceUser";
import MTMBenefitCheck from "../../components/MTMBenefitCheck/MTMBenefitCheck";
import Welcome from "../../components/Welcome/Welcome";
import { ServicesTypesComponentLoad } from "../../types/ApplicationTypes";
import WandaPlusSubscription from "../../components/WandaPlusSubscription/WandaPlusSubscription";
import SomeoneElse from "../../components/CreatePerson/SomeoneElse";
import Myself from "../../components/CreatePerson/Myself";
import TrustedContactsForm from "../../components/CreatePerson/Forms/TrustedContactsForm";
import { useServiceUserCreationCtx } from "../../context/ServiceUserCreationContext";

function WelcomeContainer() {
  const { pageTypeCtx } = useServiceUserCreationCtx();
  const [pageType, setPageType] = pageTypeCtx;
  const [clearFields, setClearFields] = useState<boolean>(false);

  const {
    relationshipTypesCtx,
    getRelationshipList,
  } = useServiceUserCreationCtx();

  const [relationshipTypes] = relationshipTypesCtx;

  useEffect(() => {
    !relationshipTypes && getRelationshipList();
  }, []);

  return <div>{componentSwitch(pageType)}</div>;
  function componentSwitch(pageType: string) {
    switch (pageType) {
      case ServicesTypesComponentLoad.MTMBenefitCheck:
        return <MTMBenefitCheck setPageType={setPageType} />;
      case ServicesTypesComponentLoad.AddAnotherServiceUser:
        return (
          <AddAnotherServiceUser
            setPageType={setPageType}
            clearFields={clearFields}
            setClearFields={setClearFields}
          />
        );
      case ServicesTypesComponentLoad.DashBoard:
        return (window.location.hash = `/DashBoard`);
      case ServicesTypesComponentLoad.ManageServiceUser:
        return (window.location.hash = `/DashBoard/ManageServiceUsers`);
      case ServicesTypesComponentLoad.SomeoneElseWillUseServices:
        return <SomeoneElse />;
      case ServicesTypesComponentLoad.MyselfWillUseServices:
        return <Myself />;
      case ServicesTypesComponentLoad.TrustedContacts:
        return <TrustedContactsForm setPageType={setPageType} />;
      case ServicesTypesComponentLoad.WandaPlusSubscription:
        return <WandaPlusSubscription setPageType={setPageType} />;
      default:
        return <Welcome setPageType={setPageType}></Welcome>;
    }
  }
}

export default WelcomeContainer;
